var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content__block content-about ql-editor",domProps:{"innerHTML":_vm._s(_vm.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }